import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalUser, CompanyUser } from 'src/app/core/models/users-models';

@Component({
  selector: 'craft-user-info',
  templateUrl: './craft-user-info.component.html',
  styleUrls: ['./craft-user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftUserInfoComponent {
  @Input() public user: PortalUser | CompanyUser;
  constructor() {}

  public get isDeactivated(): boolean {
    return 'accountStatus' in this.user && this.user.accountStatus === 'deactivated';
  }
}
